import styled, { css, keyframes } from 'styled-components';
import VenueDetailModal from './VenueDetailModal';

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRules = css`
  ${loadingKeyframes} 1.5s infinite;
`;

export default styled(VenueDetailModal)`
  .title-container {
    padding: 16px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-right: 48px;
    pointer-events: none;
    border-bottom: 1px solid var(--grey200);
    min-height: 87px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .subtitle {
    font-size: 16px;
    color: var(--grey700);
  }

  .container {
    padding-top: 23px;
  }

  .venue-detail {
    padding: 8px 16px;
    border-bottom: 1px solid var(--grey200);
    &.loading {
      min-height: 50px;
      position: relative;
      &:after {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transform: translateX(-100%);
        background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.05), transparent);
        animation: ${loadingKeyframesRules};
      }
    }

    .venue-title {
      font-weight: bold;
    }

    .venue-description {
      color: var(--grey700);
    }
  }

  .venue-detail {
    position: relative;
    .venue-edit-container {
      display: none;
      position: absolute;
      top: 8px;
      right: 8px;
    }

    &:hover {
      background: var(--grey100);
      .venue-edit-container {
        display: block;
      }
    }
  }

  .venue-modifications-alert {
    padding: 8px 16px;
    border-bottom: 1px solid var(--grey200);
    background: var(--accent100);
  }

  .venue-detail.isTouched {
    background: var(--accent100);
  }

  .vehicle-requirements {
    margin-top: 8px;
    display: flex;
    align-items: center;
    > div:first-child {
      margin-right: 16px;
      color: var(--secondary500);
    }
  }

  .link {
    color: var(--primary);
  }

  .develop-info {
    font-size: 10px;
    text-align: right;
    padding: 2px 10px;
    font-style: italic;
    a,
    a:visited {
      color: var(--grey700);
      text-decoration: none;
    }
  }

  .venue-detail-hours {
    display: flex;
    justify-content: space-between;

    .week-day {
      padding-right: 8px;
    }

    .detailed-hours {
      > span {
        margin-right: 4px;
      }
      > span:last-child {
        margin-right: 0;
      }
    }
  }

  .venue-contact {
    margin-bottom: 4px;
  }

  .error {
    padding: 16px;
    color: var(--redCherry);
    text-align: center;
  }

  .field-container {
    margin-top: 8px;
  }

  .venue-save-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }

  .field-bottom-margin {
    margin-bottom: 12px;
  }

  .contacts-edition {
    margin-top: 8px;
  }

  .contacts-edition-element {
    padding: 8px;
    background: var(--grey200);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    > div > div:first-child {
      margin-bottom: 8px;
    }
    > div:first-child {
      flex: 1;
      margin-right: 8px;
    }
  }

  .field-error {
    color: var(--error900);
    margin-top: 4px;
  }

  .field-error.left-margin {
    margin-top: 0;
    margin-left: 16px;
  }

  .half-fields {
    display: flex;
    > div {
      flex: 1;
    }
    > div:first-child {
      margin-right: 8px;
    }
  }

  .success-creation {
    text-align: center;
    padding: 24px;
    padding-bottom: 72px;
  }

  .success-title {
    font-weight: medium;
    font-size: 18px;
    color: var(--success900);
    margin-top: 16px;
  }

  .duplicated-hint {
    color: var(--grey100);
  }

  .time-field-container {
    display: flex;

    > div {
      display: flex;
      align-items: center;
      margin-right: 16px;

      span {
        margin-right: 10px;

        &.hidden {
          opacity: 0;
        }
      }
      .input {
        width: 80px;
        input {
          padding-top: 0.4rem;
        }
      }
    }
  }

  .schedule-segment-container {
    margin-top: 24px;
    margin-bottom: 12px;

    &:first-child {
      margin-top: 0;
    }

    .schedule-days-container {
      label {
        width: 32px;
        text-align: center;
      }
    }

    .rounded-btn {
      border-radius: 100%;
    }
  }
`;
